module.exports = __webpack_public_path__ + "img/discovery.f71f68.svg";